eliminarFot<template>
  <div>
    <b-row v-if="banderaTicketValidado == 1">
      <b-col class="wrapper fadeInDown">
        <b-row>
          <b-col>

            <div>
              <b-row>
                <b-col>
                  <b-alert class="text-center" show variant="danger">El VALE YA NO SE ENCUENTRA DISPONIBLE PARA SU
                    VALIDACION (V)</b-alert>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="banderaTicketValidado == 2">
      <b-col class="wrapper fadeInDown">
        <b-row>
          <b-col>

            <div>
              <b-row>
                <b-col>
                  <b-alert class="text-center" show variant="danger">El VALE YA NO SE ENCUENTRA DISPONIBLE PARA SU
                    VALIDACION (C)</b-alert>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="banderaTicketValidado != 1 && banderaTicketValidado != 2">
      <b-col class="wrapper fadeInDown">
        <b-row id="formContent">
          <b-col>

            <div v-if="banderaVale == 2">
              <b-row>
                <b-col class="card-option">
                  <img src="@/assets/logo.png" id="icon" alt="User Icon" class="mb-4 mt-4" />
                  <!-- Vale y password -->
                  <b-form-input size="sm" placeholder="Ingrese el número de vale" v-model="nFolioVale"
                    class="mb-3 mt-4"></b-form-input>
                  <!--<b-form-input size="sm" placeholder="Ingrese su contraseña" v-model="pass"></b-form-input>-->
                  <b-button pill @click="codigoProveedor()" size="lg" variant="success" class="mb-4">Consultar
                    Vales</b-button>
                </b-col>
              </b-row>
            </div>

            <div v-if="banderaVale == 1">
              <p></p>
              <h3>Vale de gasolina folio {{ nFolioVale }}</h3>
              <p></p>
              <b-row align-h="center" align="center">
                <!--UNIDAD-->
                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="truck" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Unidad</h6>
                    {{ unidad }}
                  </div>
                </b-col>

                <!--OPERADOR-->
                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="person" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Operador</h6>
                    {{ operador }}
                  </div>
                </b-col>

                <!--DATOS DE CARGA-->

                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="clipboard-check" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Datos Carga</h6>
                    {{ consumible }}
                    {{ litros }}
                  </div>
                </b-col>
              </b-row>
              <b-row align-h="center" align="center">
                <b-col>
                  <b-button pill class="mt-2 mb-4" size="lg" @click="despacharVale()" variant="success">Registrar
                    Carga</b-button>
                </b-col>
              </b-row>

              <b-row v-if="banderaEsAdmin == 1" align-h="center" align="center">
                <b-col>
                  <b-button pill class="mt-2 mb-4" size="lg" @click="consultaOtroVale()"
                    variant="danger">Regresar</b-button>
                </b-col>
              </b-row>
            </div>

            <b-modal v-model="modalShow3" hide-footer header-text-variant="light" header-bg-variant="dark"
              title="Veirfique la información">
              <b-row align-h="center" align="center">
                <b-col cols="12" lg="12">

                  <b-row v-if="banderaMostrarCheck != 1">
                    <b-col>
                      <b-check v-model="checkFoto" value=1 unchecked-value=0>Validar carga sin foto</b-check>
                    </b-col>
                  </b-row>

                  <p></p>

                  <b-row>
                    <b-col>
                      <h5 v-if="checkFoto == 0">Adjunte la foto de su ticket de bomba</h5>
                    </b-col>
                  </b-row>

                  <!--<h5 v-if="banderaSpinnerCamara == 2">Verifique la información</h5>-->

                  <!--
                  <b-row v-if="fechaCarga != ''">
                    <b-col>
                      <p></p>
                      <h5 style="color: purple;">Fecha de carga:</h5>
                      <b-form-datepicker v-model="fechaCarga" placeholder="Ingresa la fecha"
                        :state="validacionFechaCarga"></b-form-datepicker>
                    </b-col>
                  </b-row>
                  -->
                  <!--
                  <b-row v-if="horaCarga != '' && horaCarga != null">
                    <b-col>
                      <p></p>
                      <h5>Hora de carga:</h5>
                      <b-form-timepicker v-model="horaCarga" placeholder="Ingresa la hora de carga"></b-form-timepicker>
                    </b-col>
                  </b-row>
                  -->

                  <b-row v-if="nFolioTicket != '' || checkFoto == 1">
                    <b-col>
                      <p></p>
                      <h5 style="color: purple;">No. Comprobante:</h5>
                      <b-form-input v-model="nFolioTicket" placeholder="Ingresa el número de comprobante"
                        :state="validacionFolioCarga"></b-form-input>
                    </b-col>
                  </b-row>
                  <!--la variable consumibleSelectedVal fue comentada en todo el codigo por falta de uso-->
                  <!--
                  <b-row v-if="consumibleSelectedVal != null">
                    <b-col>
                      <p></p>
                      <h5 style="color: purple;">Tipo de consumible:</h5>
                      <b-form-select v-model="consumibleSelectedVal" :options="tipoConsumibleVal" :state="validacionConsumibleCarga"></b-form-select>
                    </b-col>
                  </b-row>
                  -->

                  <!--
                  <b-row v-if="litrosCargadosValidacion != ''">
                    <b-col>
                      <p></p>
                      <h5 style="color: purple;">No. Litros:</h5>

                      <b-form-input class="text-center" type="number" number v-model="litrosCargadosValidacion"
                        placeholder="Ingresa el número de litros" :state="validacionLitrosCarga"></b-form-input>

                    </b-col>
                  </b-row>
                  -->

                  <!--
                  <b-row v-if="montoTotalCargado != ''">
                    <b-col>
                      <p></p>
                      <h5 style="color: purple;">Monto cargado $:</h5>
                      <b-form-input class="text-center" type="number" number v-model="montoTotalCargado"
                        placeholder="Ingresa el monto total" :state="validacionTotalCarga"></b-form-input>

                      <div v-if="montoTotalCargado > totalMontoVale">
                        <div v-if="Math.abs(totalMontoVale - montoTotalCargado) > litrosCargadosValidacion">

                          <b-alert show variant="warning">EL MONTO TOTAL CARGADO $$$ ES MAYOR AL INDICADO EN EL
                            VALE</b-alert>

                        </div>
                      </div>

                      <p></p>
                    </b-col>
                  </b-row>
                  -->

                </b-col>

                <!--PARTE CAMARA-->

                <b-col>

                  <b-row v-if="checkFoto == 0">
                    <b-col>
                      <b-row v-if="banderaSpinnerCamara != 2 && banderaSpinnerCamara != 5">
                        <b-col>
                          <b-form-file v-model="fotoBase64" :state="Boolean(fotoBase64)" placeholder=""
                            @change="convertirTicketBase64"></b-form-file>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-row v-if="banderaSpinnerCamara == 4" align-h="center" align="center">
                        <b-col>
                          <p></p>
                          <b-button pill variant="danger" size="lg" @click="eliminarFoto()">Borrar Foto</b-button>
                          <p></p>
                          <img v-bind:src="'data:image/jpeg;base64,' + fotoBase64" alt="Red dot" width="375" />
                        </b-col>
                      </b-row>
                      <p></p>

                      <!--{{ valorError }}-->

                      <b-row v-if="banderaSpinnerCamara == 4 && checkFoto != 1">
                        <b-col>
                          <b-button pill variant="success" size="lg" @click="enviarFotoTicket()"> Siguiente
                          </b-button>
                        </b-col>
                      </b-row>
                      <b-row v-if="banderaSpinnerCamara == 1">
                        <b-col>
                          <strong>Espere un momento, por favor, se está validando su carga...</strong>
                          <p></p>
                          <b-spinner label="Espere un momento, por favor, se está validando su carga..."></b-spinner>
                        </b-col>
                      </b-row>
                      <p></p>
                      <b-row v-if="banderaSpinnerCamara == 2 && checkFoto != 1">
                        <b-col>
                          <b-button pill variant="danger" size="lg" @click="regresarCarga()"> Regresar </b-button>
                        </b-col>
                      </b-row>
                      <p></p>
                      <b-row v-if="banderaSpinnerCamara == 2 || checkFoto == 1">
                        <b-col>
                          <b-button pill variant="success" size="lg" @click="finalizarCarga()"> Finalizar
                            Carga</b-button>
                        </b-col>
                      </b-row>

                      <b-row v-if="banderaSpinnerCamara == 5">
                        <b-col>
                          <strong>Espere un momento, por favor, se está validando su carga...</strong>
                          <p></p>
                          <b-spinner label="Espere un momento, por favor, se está validando su carga..."></b-spinner>
                        </b-col>
                      </b-row>

                      <p></p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-modal>
            <div v-if="banderaSpinnerCamara == 3">
              <p></p>
              <p></p>
              <b-alert variant="success" show>SU CARGA SE HA VALIDADO CON EXITO</b-alert>

            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";

export default {


  computed: {
    validacionFechaCarga() {
      return this.fechaCarga == null ? false : true
    },
    validacionFolioCarga() {
      return this.nFolioTicket == '' ? false : true
    },
    /*
    validacionConsumibleCarga() {
      return this.consumibleSelectedVal == '' ? false : true
    },
    */
    validacionLitrosCarga() {
      return this.litrosCargadosValidacion == null ? false : true
    },
    validacionTotalCarga() {
      return this.montoTotalCargado == null ? false : true
    },

    token: {
      get: function () {
        return this.$store.state.user.token;
      },
      set: function (newIsWorking) {
        this.$store.commit("updateToken", newIsWorking);
      }
    }
  },


  data() {
    return {
      //variables

      cliente: "",
      //url: "http://192.168.0.100:8080/",
      //url: "https://optimal-central-pug.ngrok-free.app/",
      url: "https://tphavawsqa.a.pinggy.link/",

      validacionProveedor: 1,
      banderaVale: 0,
      banderaCamera: 0,
      banderaBotonFinaliza: 0,
      claveProveedor: "",
      pass: "",
      modalShow: false,
      modalShow2: false,
      modalShow3: false,
      banderaOtraCantidad: "no activado",

      nLitros: "",
      nFolioTicket: "",

      //Variables Camara
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",

      fotoBase64: null,
      validacionDatos: "",
      fechaCarga: "",
      horaCarga: "",
      nFolioVale: "",

      unidad: "",
      operador: "",
      consumible: "",
      litros: "",
      litrosCargadosValidacion: "",
      banderaSpinnerCamara: 0,
      montoTotalCargado: "",
      totalMontoVale: "",

      valorUrl: "",
      valorUrlFinal: "",


      banderaTicketValidado: 0,

      banderaEsAdmin: 0,

      checkFoto: 0,

      banderaMostrarCheck: 0


      /*
      consumibleSelectedVal: null,
      tipoConsumibleVal: [
        { value: '', text: 'Seleccione el tipo de consumible' },
        { value: 'REGULAR', text: 'REGULAR' },
        { value: 'PREMIUM', text: 'PREMIUM' },
        { value: 'DIESEL', text: 'DIESEL' }
      ],
      */


      //valorError: ''
    };
  },

  created: function created() {

    const queryString = window.location.href;

    const url = new URL(queryString);

    const cliente = url.pathname.split('/')[1];

    this.cliente = cliente


    const queryString2 = window.location.search;
    const urlParams = new URLSearchParams(queryString2);

    const id = urlParams.get("id");
    /*this.consultarVales(id)*/
    /*this.consultarVales(placa)*/

    if (id != null) {
      this.banderaVale = 1;
      this.modalShow2 = true;
      this.banderaMostrarCheck = 1;

      axios({
        method: 'post',
        url: this.url + 'imprimirvale',
        params: { "codeClient": this.cliente },
        data: {
          "folio": id
        }
      })
        .then((res) => {

          this.nFolioVale = res.data.folio,
            this.unidad = res.data.unidad.descUnidad,
            this.operador = res.data.operador,
            this.consumible = res.data.tipoCombustibleVale,
            this.litros = res.data.nLitrosVale,
            this.totalMontoVale = res.data.costoTotalVale
          //this.consumibleSelectedVal = res.data.tipoConsumible


          const queryString3 = window.location.href;
          const url3 = new URL(queryString3);

          this.valorUrl3 = JSON.stringify(url3);


          if (this.valorUrl3.includes("validacion")) {

            this.banderaEsAdmin = 0
          }

        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet 6');
          }

          else {

            alert(err);

          }
        });

    } else {
      this.banderaVale = 2;
    }
  },

  methods: {

    convertirTicketBase64(evt) {
      if (evt.target.files.length > 0) {
        this.convertirTicketBase64_2(evt.target.files[0]);
      }
    },

    convertirTicketBase64_2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.fotoBase64 = base64String;
          this.banderaSpinnerCamara = 4;
        };

      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);

      this.banderaSpinnerCamara = 4;
    },

    enviarFotoTicket() {

      this.banderaMostrarCheck = 1;

      this.banderaSpinnerCamara = 1;

      this.validacionDatos = {
        fotoTicket: this.fotoBase64,
        folioTicket: this.nFolioTicket,
        litrosCargados: this.litrosCargadosValidacion,
        fechaCarga: this.fechaCarga,
        folioVale: this.nFolioVale,
        costoTotal: this.montoTotalCargado,
        //tipoConsumible: this.consumibleSelectedVal
      };







      const queryString = window.location.href;
      const url = new URL(queryString);
      this.valorUrl = JSON.stringify(url);

      if (this.valorUrl.includes("login")) {
        //alert("es el administrador")










        axios({
          method: "post",
          url: this.url + "lecturaticketadmin",
          params: { codeClient: this.cliente },
          data: this.validacionDatos,
          headers: {
            'Authorization': this.token,

          }
        })
          .then((res) => {

            this.banderaMostrarCheck = 1;

            const queryString = window.location.href;
            const url = new URL(queryString);

            this.valorUrl = JSON.stringify(url);



            if (this.valorUrl.includes("login")) {
              //alert("es el administrador")




              this.registros = [];
              this.banderaSpinnerCamara = 2;
              this.nFolioTicket = res.data.folioTicket
              this.litrosCargadosValidacion = res.data.litrosCargados
              this.fechaCarga = res.data.fechaCarga
              this.montoTotalCargado = res.data.costoTotal

              //this.consumibleSelectedVal = res.data.tipoConsumible

              if (this.nFolioTicket == "") {

                this.nFolioTicket = null
                this.banderaSpinnerCamara = 2

              }

              if (this.litrosCargadosValidacion == "") {

                this.litrosCargadosValidacion = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.fechaCarga == "") {

                this.fechaCarga = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.montoTotalCargado == "") {

                this.montoTotalCargado = null,
                  this.banderaSpinnerCamara = 2

              }




              /*
              if (this.consumibleSelectedVal == "" ) {
              
              this.consumibleSelectedVal = '',
              this.banderaSpinnerCamara = 2
              
              }
              */



            }
            else {
              //alert("es el publico")

              if (res.data == "El vale ya no se encuentra disponible para su validación (V)") {

                alert("El vale ya no se encuentra disponible para su validación (V)")


                this.banderaTicketValidado = 1

              }

              if (res.data == "El vale ya no se encuentra disponible para su validación (C)") {

                alert("El vale ya no se encuentra disponible para su validación (C)")


                this.banderaTicketValidado = 2

              }



              this.registros = [];
              this.banderaSpinnerCamara = 2;
              this.nFolioTicket = res.data.folioTicket
              this.litrosCargadosValidacion = res.data.litrosCargados
              this.fechaCarga = res.data.fechaCarga
              this.montoTotalCargado = res.data.costoTotal
              //this.consumibleSelectedVal = res.data.tipoConsumible

              if (this.nFolioTicket == "") {

                this.nFolioTicket = null
                this.banderaSpinnerCamara = 2

              }

              if (this.litrosCargadosValidacion == "") {

                this.litrosCargadosValidacion = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.fechaCarga == "") {

                this.fechaCarga = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.montoTotalCargado == "") {

                this.montoTotalCargado = null,
                  this.banderaSpinnerCamara = 2

              }




              /*
              if (this.consumibleSelectedVal == "" ) {
              
              this.consumibleSelectedVal = '',
              this.banderaSpinnerCamara = 2
              
              }
              */
            }



          })
          .catch((err) => {
            //this.valorError = JSON.stringify(err.response);
            //alert(err.response.status)

            if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

              alert('Servicio no disponible, intente de nuevo más tarde');

              this.banderaSpinnerCamara = 4;
              this.banderaMostrarCheck = 1;

            }

            else if (err.response.status == 500) {

              alert('Error en la red, verifique su conexión a internet');

              this.banderaSpinnerCamara = 4;
              this.banderaMostrarCheck = 1;
            }

            else {

              if (err.config.headers.Authorization != null) {

                const queryString = window.location.href;
                const url = new URL(queryString);
                const cliente = url.pathname.split('/')[1];
                window.location.href = '/' + cliente + '/login';
              }


              //alert('Servicio no disponible, intente de nuevo más tarde')

            }

          });






      }



      else {
        //alert("es el publico")










        axios({
          method: "post",
          url: this.url + "lecturaticket",
          params: { codeClient: this.cliente },
          data: this.validacionDatos,
          headers: {
            'Authorization': this.token,

          }
        })
          .then((res) => {

            this.banderaMostrarCheck = 1;

            const queryString = window.location.href;
            const url = new URL(queryString);

            this.valorUrl = JSON.stringify(url);



            if (this.valorUrl.includes("login")) {
              //alert("es el administrador")




              this.registros = [];
              this.banderaSpinnerCamara = 2;
              this.nFolioTicket = res.data.folioTicket
              this.litrosCargadosValidacion = res.data.litrosCargados
              this.fechaCarga = res.data.fechaCarga
              this.montoTotalCargado = res.data.costoTotal

              //this.consumibleSelectedVal = res.data.tipoConsumible

              if (this.nFolioTicket == "") {

                this.nFolioTicket = null
                this.banderaSpinnerCamara = 2

              }

              if (this.litrosCargadosValidacion == "") {

                this.litrosCargadosValidacion = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.fechaCarga == "") {

                this.fechaCarga = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.montoTotalCargado == "") {

                this.montoTotalCargado = null,
                  this.banderaSpinnerCamara = 2

              }




              /*
              if (this.consumibleSelectedVal == "" ) {
              
              this.consumibleSelectedVal = '',
              this.banderaSpinnerCamara = 2
              
              }
              */



            }
            else {
              //alert("es el publico")

              if (res.data == "El vale ya no se encuentra disponible para su validación (V)") {

                alert("El vale ya no se encuentra disponible para su validación (V)")


                this.banderaTicketValidado = 1

              }

              if (res.data == "El vale ya no se encuentra disponible para su validación (C)") {

                alert("El vale ya no se encuentra disponible para su validación (C)")


                this.banderaTicketValidado = 2

              }



              this.registros = [];
              this.banderaSpinnerCamara = 2;
              this.nFolioTicket = res.data.folioTicket
              this.litrosCargadosValidacion = res.data.litrosCargados
              this.fechaCarga = res.data.fechaCarga
              this.montoTotalCargado = res.data.costoTotal
              //this.consumibleSelectedVal = res.data.tipoConsumible

              if (this.nFolioTicket == "") {

                this.nFolioTicket = null
                this.banderaSpinnerCamara = 2

              }

              if (this.litrosCargadosValidacion == "") {

                this.litrosCargadosValidacion = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.fechaCarga == "") {

                this.fechaCarga = null,
                  this.banderaSpinnerCamara = 2

              }

              if (this.montoTotalCargado == "") {

                this.montoTotalCargado = null,
                  this.banderaSpinnerCamara = 2

              }




              /*
              if (this.consumibleSelectedVal == "" ) {
              
              this.consumibleSelectedVal = '',
              this.banderaSpinnerCamara = 2
              
              }
              */
            }



          })
          .catch((err) => {
            //this.valorError = JSON.stringify(err.response);
            //alert(err.response.status)

            if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

              alert('Servicio no disponible, intente de nuevo más tarde');

              this.banderaSpinnerCamara = 4;
              this.banderaMostrarCheck = 1;

            }

            else if (err.response.status == 500) {

              alert('Error en la red, verifique su conexión a internet');
              this.banderaSpinnerCamara = 4;
              this.banderaMostrarCheck = 1;
            }

            else {

              if (err.config.headers.Authorization != null) {

                const queryString = window.location.href;
                const url = new URL(queryString);
                const cliente = url.pathname.split('/')[1];
                window.location.href = '/' + cliente + '/login';
              }


              //alert('Servicio no disponible, intente de nuevo más tarde')

            }

          });






      }

    },

    eliminarFoto() {

      this.banderaSpinnerCamara = 0;
      this.fotoBase64 = null;

    },


    regresarCarga() {


      this.banderaMostrarCheck = 0;
      this.banderaSpinnerCamara = 0;
      this.fotoBase64 = null;
      this.fechaCarga = "";
      this.nFolioTicket = "";
      //this.consumibleSelectedVal = null;
      this.litrosCargadosValidacion = "";
      this.montoTotalCargado = "";


    },


    finalizarCarga() {

      this.validacionDatos = {
        fotoTicket: this.fotoBase64,
        folioTicket: this.nFolioTicket,
        litrosCargados: this.litrosCargadosValidacion,
        fechaCarga: this.fechaCarga,
        folioVale: this.nFolioVale,
        //tipoConsumible: this.consumibleSelectedVal,
        costoTotal: this.montoTotalCargado

      };

      this.banderaSpinnerCamara = 5;

      /*VALIDACION ADMIN*/

      const queryStringFinal = window.location.href;
      const urlFinal = new URL(queryStringFinal);

      this.valorUrlFinal = JSON.stringify(urlFinal);


      if (this.valorUrlFinal.includes("login")) {
        //alert("es el admin Finaliza")

        axios({
          method: "post",
          url: this.url + "confirmavaleadmin",

          data: this.validacionDatos,
          headers: {
            'Authorization': this.token,

          }
        })
          .then(() => {
            this.registros = [];
            this.banderaSpinnerCamara = 3;
            this.modalShow3 = false;
            this.banderaVale = 2
            this.nFolioVale = ''
            this.checkFoto = 0
            this.banderaMostrarCheck = 0

          })
          .catch((err) => {
            //alert(err);

            //alert(err.config.headers.Authorization)

            //if (err.config.headers.Authorization != null) {

            //  const queryString = window.location.href;
            //  const url = new URL(queryString);
            //  const cliente = url.pathname.split('/')[1];
            //  window.location.href = '/' + cliente + '/login';
            //}

            alert(err + ' Servicio no disponible, intente de nuevo más tarde');
          });

      }

      else {
        //alert("es el publico Finaliza")

        axios({
          method: "post",
          url: this.url + "confirmavale",
          params: { codeClient: this.cliente },
          data: this.validacionDatos,

        })
          .then(() => {
            this.registros = [];
            this.banderaSpinnerCamara = 3;
            this.modalShow3 = false;
          })
          .catch((err) => {
            //alert(err);

            //alert(err.config.headers.Authorization)


            if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

              alert('Servicio no disponible, intente de nuevo más tarde');

            }

            else if (err.response.status == 500) {

              alert('Error en la red, verifique su conexión a internet');

            }

            else {

              alert('Servicio no disponible, intente de nuevo más tarde');

            }


          });

      }




    },


    consultaOtroVale() {
      this.banderaVale = 2
      this.nFolioVale = ''
    },


    codigoProveedor() {


      this.banderaEsAdmin = 1;
      this.banderaSpinnerCamara = 0;
      this.fechaCarga = '';
      this.nFolioTicket = '';
      this.litrosCargadosValidacion = '';
      this.montoTotalCargado = '';


      this.banderaVale = 1;

      this.modalShow2 = true;

      axios({
        method: 'post',
        url: this.url + 'imprimirvale',
        params: { "codeClient": this.cliente },
        data: {
          "folio": this.nFolioVale
        },
        headers: {
          'Authorization': this.token,

        }
      })
        .then((res) => {

          this.nFolioVale = res.data.folio,
            this.unidad = res.data.unidad.descUnidad,
            this.operador = res.data.operador,
            this.consumible = res.data.tipoCombustibleVale,
            this.litros = res.data.nLitrosVale,
            this.totalMontoVale = res.data.costoTotalVale

        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {

              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split('/')[1];
              window.location.href = '/' + cliente + '/login';
            }

            //alert(err + ' Servicio no disponible, intente de nuevo más tarde');

            //alert(err);

          }
        });
    },

    despacharVale() {
      this.modalShow3 = true;
    },

  },
};
</script>

<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #ffffff;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>
